import { Button } from "@/components/ui/button";

const CTARow = () => {
  const scrollToKit = () => {
    document.querySelector("#kit-section")?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToTemplates = () => {
    document
      .querySelector("#templates-section")
      ?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="py-8 bg-gradient-to-r from-muted/30 via-background to-muted/30">
      <div className="container-custom">
        <div className="flex flex-wrap items-center justify-center gap-4">
          <Button variant="gold" size="lg" onClick={scrollToKit}>
            Get the Complete DIY Kit ($99)
          </Button>
          <Button variant="outline" size="lg" onClick={scrollToTemplates}>
            Shop Templates
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CTARow;
